import { useEffect, useRef } from "react";
import useBackendAction from "./useBackendAction";

function useBackend(call, dependencies = [], conditionalCall) {
  const { data, response, feedback, fetch, updateData, setData } = useBackendAction(call);

  function shouldCallBackend() {
    if (pendingCall.current) return false;
    if (conditionalCall !== undefined) {
      if (typeof conditionalCall === "function") return conditionalCall();
      return conditionalCall;
    }
    return true;
  }

  // this is safety handle for React.StrictMode remounting (we don't need to call backend twice, not even on localhost)
  const pendingCall = useRef(false);
  useEffect(
    () => {
      if (!shouldCallBackend()) return;

      pendingCall.current = true;
      fetch().then(() => (pendingCall.current = false));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...dependencies],
  );

  return {
    data,
    response,
    feedback,
    updateData,
    setData,
    fetch,
  };
}

export default useBackend;
